export default {"src":"/_next/static/media/zoom-video-icon.dddeb007.svg","height":60,"width":60};